import React, { useEffect, useState } from 'react'
import CMS from '../../components/cms/CMS'
import PageBanner from '../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import CrudMenuGroup from './CrudMenuGroup'
import { useDispatch, useSelector } from 'react-redux'
import { fetchMenuGroupGetAll } from '../../redux/slices/menuGroupGetAllSlice'
import CMSTable from '../../components/general/CMSTable'
import { useNavigate } from 'react-router-dom'
import { fetchMenuGroupDelete } from '../../redux/slices/menuGroupDeleteSlice'
import { columns } from '../../utilities/columns/menuGroupColumns'

const MenuGroupPage = () => {
    const [modal, setModal] = useState(false)
    const [changed, setChanged] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const menuGroup = useSelector((state) => state.menuGroupGetAll.data)
    const lang = useSelector((state) => state.lang.lang)
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigation = useNavigate()

    const getData = async () => {
        await dispatch(fetchMenuGroupGetAll())
        setChanged(false)
    }

    const deleteData = async (id) => {
        await dispatch(fetchMenuGroupDelete({ id: id }))
        getData()
    }

    useEffect(() => { getData() }, [dispatch, changed])

    return (
        <CMS>
            <PageBanner
                modal={modal}
                setModal={setModal}
                title={t("menu_management")}
                description={t("menu_management_desct")}
                buttonText={t("add_menu_group")}
            />

            <CMSTable
                columns={columns({
                    t: t,
                    modal: modal,
                    setModal: setModal,
                    lang: lang,
                    deleteData: deleteData,
                    navigation: navigation,
                    setSelectedItem: setSelectedItem
                })}
                data={menuGroup}
            />

            <CrudMenuGroup
                showMenu={modal}
                setShowMenu={setModal}
                setChanged={setChanged}
                setSelectedItem={setSelectedItem}
                selectedItem={selectedItem}
                t={t}
            />
        </CMS>
    )
}

export default MenuGroupPage
